// src/constants/giftCategories.js
export const GIFT_CATEGORIES = [
  { key: "same_day",             label: "Same Day",            short: "Same Day" },
  { key: "flowers",               label: "Flowers",              short: "Flowers" },
  { key: "women_gifts",           label: "Women Gift Ideas",     short: "Women Gift" },
  { key: "mens_gifts",            label: "Men's Gift",           short: "Men's Gift" },
  { key: "customized_packages",   label: "Customized Packages",  short: "Customized" },
  { key: "other_packages",        label: "Other Packages",       short: "Other" },
];

export const getCategoryLabel = (key) =>
  GIFT_CATEGORIES.find((c) => c.key === key)?.label || key;